import React from "react";
import {
  ObjectAnswerTypeCssClasses,
  ObjectAnswerTypeTitles
} from "../../ObjectsUIHelpers";
import { FormattedMessage } from "react-intl";
export const AnswerTypeColumnFormatter = (cellContent, row) => (
  <span

    className={`label label-lg label-light-${
    
      ObjectAnswerTypeCssClasses[row.answerType-1]
    } label-inline`}
  >
    <FormattedMessage id= {ObjectAnswerTypeTitles[row.answerType-1]}/>
  </span>
);
